function determineIsStringValid(str?: string) {
  return str ? str.trim().length > 0 : false
}

export default determineIsStringValid
